<template>
  <span>
    <!-- select2 will append the rendered content after the original select tag, so we have to
     wrap it in a span tag in order to get the whole content by $el -->
    <select ref="select">
      <slot></slot>
    </select>
  </span>
</template>

<script>
import 'select2';
import 'select2/dist/css/select2.min.css';
import 'select2-theme-bootstrap4/dist/select2-bootstrap.min.css';

export default {
  props: {
    configs: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Array],
      default: null,
    },
  },
  mounted() {
    this.initSelect2();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    initSelect2() {
      this.select = $(this.$refs.select)
        .select2(this.configs)
        .val(this.value)
        .trigger('change')
        .on('change', (e) => {
          this.$emit('input', $(e.target).val());
        });
    },
    destroy() {
      this.select.off().select2('destroy');
    },
  },
};
</script>

<style>
.select2-search__field {
  /* fix placeholder display issue when enabled multiple selecting */
  width: auto !important;
}
</style>
